import { render, staticRenderFns } from "./HeaderDetailComponentGlobal.vue?vue&type=template&id=1eafcbb8&scoped=true&"
import script from "./HeaderDetailComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./HeaderDetailComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDetailComponentGlobal.vue?vue&type=style&index=0&id=1eafcbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eafcbb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VDivider,VIcon,VSpacer})
